import { render } from "./articlePreview.vue?vue&type=template&id=bcb1f0b8&scoped=true"
import script from "./articlePreview.vue?vue&type=script&lang=js"
export * from "./articlePreview.vue?vue&type=script&lang=js"

import "./articlePreview.vue?vue&type=style&index=0&id=bcb1f0b8&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb1f0b8"]])

export default __exports__